(function () {
/*
 * -----------------------------------------------------------------------------
 * LAZY LOADED
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @kind component
 * @overview Progressive lazy loading attibute helper.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("lazy-loaded") === undefined) {
    class LazyLoaded extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.intersection = (entries)=>entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    entry.target.setAttribute("loading", "eager");
                    this.observer.unobserve(entry.target);
                });
            this.observer = new IntersectionObserver(this.intersection);
            this.querySelectorAll('[loading="lazy"]').forEach(this.observer.observe.bind(this.observer));
        }
    }
    customElements.define("lazy-loaded", LazyLoaded);
}



})();
